<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showPremiumsModal" :title="$t('Premiums')" size="lg" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable>
      <premium-tiers :enable-first-tier-removal="true" :model="model" show-minimum-premium-field/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "../../../../../core/widgets/PercentageInputWidget";
  import Premium from "@/core/components/premium-tiers/Premium.model";
  import PremiumsFormData from "@/modules/sales/models/PremiumsFormData.model";
  import PremiumTiers from "@/core/components/premium-tiers/PremiumTiers.vue";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "PremiumsModal",
    components: {PremiumTiers, PercentageInputWidget, CurrencyInputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new PremiumsFormData()
      }
    },
    computed: {
      ...mapState({
        showPremiumsModal: state => state.termsData.showPremiumsModal,
        termDataPremiums: state => state.termsData.premiums,
        minimum_premium: state => state.termsData.minimum_premium,
      }),
    },
    methods: {
      ...mapActions(['togglePremiumsModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let tmpData = this.model.toJSON()
        let requestData = tmpData.premiums.map(premium => premium.toJSON());
        if (requestData && requestData.length < 1) {
          tmpData.minimum_premium = null
        }
        let response = await this.saveTermsPartialData({
          premiums: requestData,
          minimum_premium: tmpData.minimum_premium
        });
        this.loading = false;

        if (response.success) {
          this.togglePremiumsModal(false);
          this.$toast('success', this.$t('Premiums were successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body.premiums) {
              this.model.premiums[index].setMultipleErrors(response.body.premiums[index]);
            }
          }
        }
      },
      onShow() {
        this.model = new PremiumsFormData({
          minimum_premium: this.minimum_premium,
          premiums: this.termDataPremiums.map(data => new Premium(data))
        })
      },
      onHidden() {
        this.model = new PremiumsFormData()
        this.togglePremiumsModal(false);
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>

